import { render, staticRenderFns } from "./createmenu.vue?vue&type=template&id=1a11b0f3&"
import script from "./createmenu.vue?vue&type=script&lang=ts&"
export * from "./createmenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createmenu.vue"
export default component.exports